import { Route, Routes } from "react-router-dom";

import Landing from "../pages/Landing/Landing";
import { RoutePath } from "./RoutePath";
import Login from "../pages/Login/Login";
import Register from "../pages/Register/Register";
import UserInformation from "../pages/UserInformation/UserInformation";
import ForgotPassword from "../pages/Forgot/ForgotPassword";
import ServicePage from "../pages/Service/Service";
import Payment from "../pages/Payment/Payment";
import CriminalCheck from "../pages/CriminalCheck/CriminalCheck";
import MyChecks from "../pages/MyChecks/MyChecks";
import ViewOrder from "../pages/ViewOrder/ViewOrder";
import FingerPrintsPayment from "../pages/FingerPrintsPayment/FingerPrintsPayment";

export const RootRouter = () => {
  return (
    <Routes>
      <Route path={RoutePath.dashboard} element={<Landing />} />
      <Route path={RoutePath.login} element={<Login />} />
      <Route path={RoutePath.register} element={<Register />} />
      <Route path={RoutePath.inspection} element={<UserInformation />} />
      <Route path={RoutePath.forgot} element={<ForgotPassword />} />
      <Route path={RoutePath.services} element={<ServicePage />} />
      <Route path={`${RoutePath.payments}/:id`} element={<Payment />} />
      <Route path={RoutePath.criminalCheck} element={<CriminalCheck />} />
      <Route path={RoutePath.myChecks} element={<MyChecks />} />
      <Route path={`${RoutePath.viewOrder}`} element={<ViewOrder />} />
      <Route path={`${RoutePath.viewOrder}/:id`} element={<ViewOrder />} />
      <Route
        path={`${RoutePath.fingerPrintPayment}/:id`}
        element={<FingerPrintsPayment />}
      />
    </Routes>
  );
};
